import React from 'react'
import Pagination from '@src/routes/SemiConfigurators/components/Pagination'
import { semiConfigContext } from '../Shrna'
import { useShrnaSearchTermLazyQuery } from '@src/queries/ShrnaProductSearchQuery.generated'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import { SemiConfiguratorValues } from '../../../utils/constants'

const PaginationForShrna = () => {
  const { state, dispatch } = React.useContext(semiConfigContext)
  const [noOfPage, setNoOfPage] = React.useState(1)
  const [getShrnaSearchTerm, { data, loading }] = useShrnaSearchTermLazyQuery()
  const perPage = state.searchValue.count
  const pageCount = state.paginationData.totalCount
  const [isPaginationComponentSelected, setPaginationComponentSelected] =
    React.useState(false)

  const handlePageChange = (page: number) => {
    setPaginationComponentSelected(true)
    dispatch({
      type: 'CHECK_ACTIVE_LINK',
      data: {
        ...state.checkActiveLink,
        itemSelectionLink: false,
      },
    })
    dispatch({ type: 'SET_PAGINATION_PAGE', data: page })
    return page
  }

  const searchResult = async (obj) => {
    await getShrnaSearchTerm({ variables: { input: obj } })
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getShrnaSearchTerm?.serverError) {
        if (isPaginationComponentSelected) {
          const div = document.getElementById('shrnaResultsSection')
          if (div) {
            const rect = div.getBoundingClientRect()
            window.scrollTo(0, rect.top - 75)
          }
        }
        dispatch({
          type: 'UPDATE_SEARCH_RESPONSE',
          data: data.getShrnaSearchTerm,
        })
        if (
          data.getShrnaSearchTerm.count !== null &&
          data.getShrnaSearchTerm.count !== undefined
        ) {
          dispatch({
            type: 'UPDATE_PAGINATION_DATA',
            data: {
              ...state.paginationData,
              totalCount: data.getShrnaSearchTerm.count,
              page: state.setPage,
              reagentItemsCount:
                data.getShrnaSearchTerm.cloneInformation?.length,
            },
          })

          if (!data.getShrnaSearchTerm.cloneInformation?.length) {
            dispatch({ type: 'SET_PAGINATION_PAGE', data: 1 })
            dispatch({
              type: 'UPDATE_PAGINATION_DATA',
              data: {
                ...state.paginationData,
                totalCount: data.getShrnaSearchTerm.count,
                page: 1,
                reagentItemsCount:
                  data.getShrnaSearchTerm.cloneInformation?.length,
              },
            })
            dispatch({
              type: 'UPDATE_SEARCH_TERM',
              data: { ...state.searchValue, page: 1 },
            })
          }
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    if (state.setPage !== undefined) {
      dispatch({
        type: 'UPDATE_SEARCH_TERM',
        data: { ...state.searchValue, page: state.setPage },
      })
      const updatedData = { ...state.searchValue, page: state.setPage }
      searchResult(updatedData)
    }
    let result: number
    result = 1
    if (data !== undefined) {
      if (!data.getShrnaSearchTerm?.serverError) {
        if (
          data.getShrnaSearchTerm.count !== null &&
          data.getShrnaSearchTerm.count !== undefined
        ) {
          const updatedPageCount = pageCount / perPage
          result = Math.ceil(updatedPageCount)
          setNoOfPage(result)
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    if (state.stepNo === 2) {
      dispatch({
        type: 'CHECK_ACTIVE_LINK',
        data: {
          ...state.checkActiveLink,
          specificationLink: true,
        },
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [
    state.setPage,
    data,
    state.paginationData.totalCount,
    state.searchValue.count,
  ])

  return (
    <div>
      <Pagination
        curPage={state.setPage}
        numPages={noOfPage}
        clickHandler={handlePageChange}
      />
      {loading &&
        state.stepNo === 1 &&
        !state.checkActiveLink.itemSelectionLink && <CircleLoader />}
    </div>
  )
}

export default PaginationForShrna
